export default __webpack_public_path__ + "dff84f3d4c57521160341c686742603f.png";